<template>
  <div :class="{active: myShowPicker}" class="wh-popup-dynamic-select">
    <span
      @click="togglePopupPicker(true)"
    >
      <slot>
        <van-field
          :label="label"
          :name="name"
          :placeholder="placeholder"
          :right-icon="rightIcon"
          :rules="rules"
          :value="value"
          border
          clickable
          readonly
          style="padding: 0;"
        />
      </slot>
    </span>
    <van-popup
      v-model="myShowPicker"
      :style="{
        height: height
      } "
      class="popup"
      position="bottom"
      @open="open"
    >
      <div>
        <div class="wh-flex-between head">
          <van-icon name="arrow-left" @click="hidePopup" />
          <van-search
            v-model.trim="searchKeyword"
            :background="'transparent'"
            :placeholder="searchPlaceholder"
            class="search-unit"
            clearable
            shape="round"
            show-action
            @search="handleSearch"
          >
            <template #action>
              <van-button
                block
                class="search-btn"
                native-type="button"
                round
                size="small"
                type="primary"
                @click="handleSearch"
              >
                搜索
              </van-button>
            </template>
          </van-search>
          <slot name="special" />
        </div>
        <div v-if="historyKey && historyList.length" class="tags">
          <div class="wh-flex-between" style="padding: 5px 0;">
            <span>历史记录</span>
            <van-button icon="delete" native-type="button" size="mini" type="info" @click="setHistory([])">
              清空
            </van-button>
          </div>
          <van-tag v-for="(item,key) in historyList" :key="key" class="tag" @click="handleHistoryTag(item)">
            {{ item }}
          </van-tag>
        </div>
      </div>
      <wh-mobile-list
        ref="list"
        :data-src="dataSrc"
        :extra-params="extraParams"
        :get-list-data="getListData"
        class="select-list"
        height="100%"
      >
        <template v-slot="{list}">
          <slot :list="list" name="list">
            <van-cell v-for="(item, index) in list" :key="index" :title="index" />
          </slot>
        </template>
      </wh-mobile-list>
    </van-popup>
  </div>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'

export default {
  name: 'WhPopupDynamicSelect',
  components: { WhMobileList },
  props: {
    dataSrc: {
      type: String,
      default: ''
    },
    getListData: {
      type: Function,
      default: (res) => {
        return res.data.list || []
      }
    },
    extraParams: {
      type: Object,
      default() {
        return {}
      }
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    height: {
      type: String,
      default: '100%'
    },
    // 搜索记录存储关键字
    historyKey: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    rightIcon: {
      type: String,
      default: undefined
    },
    searchPlaceholder: {
      type: String,
      default: '请选择'
    },
    label: {
      type: String,
      default: undefined
    },
    showPicker: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    searchName: {
      type: String,
      default: 'searchKey'
    },
    value: {
      type: [String, Number, Boolean, Date],
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      myShowPicker: false,
      searchKeyword: '',
      historyList: [],
      historyKeyPrefix: 'dynamicSelect_'
    }
  },
  watch: {
    showPicker: {
      handler(newVal) {
        this.myShowPicker = newVal
      },
      immediate: true
    },
    myShowPicker: {
      handler(newVal) {
        if (newVal) {
          this.searchKeyword = ''
          this.$set(this.extraParams, 'keyword', undefined)
        }
      }
    }
  },
  methods: {
    open() {
      this.$emit('open')
      this.historyList = this.getHistory()
    },
    hidePopup() {
      this.$emit('close')
      this.myShowPicker = false
    },
    togglePopupPicker(val) {
      this.myShowPicker = val
      this.$emit('update:showPicker', val)
    },
    setHistory(list = []) {
      if (list.length > 10) { // 最多表里10个历史记录
        this.historyList = list.slice(-10)
      } else {
        this.historyList = list
      }
      const setList = new Set(list)
      this.historyList = Array.from(setList)
      localStorage.setItem(this.historyKeyPrefix + this.historyKey, JSON.stringify(this.historyList))
    },
    getHistory() {
      const localHistory = localStorage.getItem(this.historyKeyPrefix + this.historyKey) || '[]'
      return JSON.parse(localHistory)
    },
    handleHistoryTag(item) {
      this.searchKeyword = item
      this.$set(this.extraParams, this.searchName, item)
    },
    handleSearch() {
      if (this.historyKey) {
        if (this.searchKeyword) {
          this.historyList.push(this.searchKeyword)
        }
        this.setHistory(this.historyList)
      }
      this.$set(this.extraParams, this.searchName, this.searchKeyword)
    }
  }
}
</script>

<style lang='less' scoped>
.popup {
  display: flex;
  flex-direction: column;
}
.wh-popup-dynamic-select {
  padding: 10px 16px;
}
.tags {
  padding: 0 20px 20px 20px;
  background: #eeeeee;
  .tag {
    padding: 4px;
    margin-right: 6px;
  }
}
.head {
  padding: 0 10px;
  .search-unit {
    width: 90%;
  }
}
</style>
